The type of event, i.e. `CandidateProfilePurchased`.
